var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-aos":"fade-right"}},[(_vm.templateNumber === 1)?_c('News1',{attrs:{"news":_vm.news,"title":_vm.title}}):(_vm.templateNumber === 2)?_c('News2',{attrs:{"news":_vm.news,"title":_vm.title}}):(_vm.templateNumber === 3)?_c('News4',{attrs:{"news":_vm.news,"title":_vm.title}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }